/**
 * Whether a nav button is the current page: `pathname` equals its `link` or one
 * of its `matchPaths`, exactly. Prefix matching would highlight Home (`/app`)
 * everywhere.
 */
const isNavButtonSelected = (button, pathname) => Boolean(
  button.link
    && [button.link, ...(button.matchPaths || [])].includes(pathname)
    && !button.noHighlightOnSelect
    && !button.disabled,
);

export default isNavButtonSelected;
